import Navbar from '@/pages/home/components/Navbar';
import Philosophy from '@/pages/home/components/Philosophy';
import Footer from '@/pages/home/components/Footer';
import PageHero from '@/components/feature/PageHero';
import PageTransition from '@/components/feature/PageTransition';
import PageCrossLink from '@/components/feature/PageCrossLink';
import useSEO from '@/hooks/useSEO';
import SchemaOrg from '@/components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const philosophySchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Our Philosophy | Higher Standard Global',
  url: `${siteUrl}/philosophy`,
  description:
    'We believe exceptional property management is not a service — it is a discipline. Every decision is made with the long view in mind.',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'Philosophy', item: `${siteUrl}/philosophy` },
    ],
  },
};

export default function PhilosophyPage() {
  useSEO({
    title: 'Our Philosophy | Higher Standard Global — Property Management Principles',
    description:
      'We believe exceptional property management is not a service — it is a discipline. Discover the guiding principles and long-view thinking behind every decision at Higher Standard Global.',
    keywords: 'property management philosophy, real estate management principles, premium property care, long-term property management approach',
    canonical: '/philosophy',
  });

  return (
    <main className="w-full min-h-screen">
      <SchemaOrg schema={philosophySchema} id="schema-philosophy" />
      <Navbar />
      <PageHero
        eyebrow="Our Guiding Principles"
        title="Philosophy"
        subtitle="We believe exceptional property management is not a service — it is a discipline. Every decision is made with the long view in mind."
        imageUrl="https://public.readdy.ai/ai/img_res/a35bac457b58a8c8d0bd6b041e5ea5dc.jpg"
      />
      <PageTransition label="Our Approach" />
      <Philosophy />
      <PageCrossLink
        prev={{
          label: 'About Us',
          eyebrow: 'Higher Standard Global',
          description: 'Learn who we are and the standard we hold ourselves to.',
          path: '/about',
        }}
        next={{
          label: 'Our Services',
          eyebrow: 'What We Do',
          description: 'Explore the full suite of disciplines we bring to every engagement.',
          path: '/services',
        }}
      />
      <Footer />
    </main>
  );
}
